import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';

import type { ISettingsViewAllStatisticsPayload } from '../types';
import {
  ADMIN_GENERAL_SETTINGS_FULL_STATS_ACCESS_PERMISSIONS,
  SETTINGS_FULL_STATS_ACCESS_ADD_QUERY_KEY,
  SETTINGS_FULL_STATS_ACCESS_ADD_URL,
  SETTINGS_FULL_STATS_ACCESS_LIST_QUERY_KEY,
} from '../constants';

export default function useSettingsFullStatsAccessRemoveMutation(): ReturnType<
  typeof useContextMutation<void, Error, ISettingsViewAllStatisticsPayload>
> {
  const { fetchPost } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<
    void,
    Error,
    ISettingsViewAllStatisticsPayload
  >({
    mutationKey: [SETTINGS_FULL_STATS_ACCESS_ADD_QUERY_KEY],
    mutationFn: (payload) => fetchPost<void>(
      SETTINGS_FULL_STATS_ACCESS_ADD_URL,
      payload,
      {

        permission: ADMIN_GENERAL_SETTINGS_FULL_STATS_ACCESS_PERMISSIONS.PROJECTSETTINGS_ADMINS_WITH_FULL_STATS_ACCESS,
      },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [SETTINGS_FULL_STATS_ACCESS_ADD_QUERY_KEY] });
      await queryClient.refetchQueries({ queryKey: [SETTINGS_FULL_STATS_ACCESS_LIST_QUERY_KEY] });
      displayPresetToast('edited');
    },
  });
}
